module.exports = __webpack_public_path__ + "img/type_40_7.prt.0de9a979.jpg";